import {
  LINE_ME_URL,
  WHATSAPP_ME_URL,
} from '../../consts/defaultConfigValues/defaultConstants'
import { WorkflowChannel } from '../../graphQL/queries/getSession/types'

interface IGetGoToChannelUrl {
  channel: `${WorkflowChannel}`
  phoneNumber: string
  text?: string
}

const urlResultMap: Record<
  `${WorkflowChannel}`,
  (args: Pick<IGetGoToChannelUrl, 'phoneNumber' | 'text'>) => string
> = {
  [WorkflowChannel.WHATSAPP]: ({ phoneNumber, text = '' }) =>
    `${new URL(phoneNumber, WHATSAPP_ME_URL).toString()}?text=${encodeURIComponent(text)}`,
  [WorkflowChannel.LINE]: ({ phoneNumber, text = '' }) =>
    `${new URL(`${phoneNumber}/${text}`, LINE_ME_URL).toString()}`,
}

const getGoToChannelUrl = ({ channel, ...rest }: IGetGoToChannelUrl) =>
  urlResultMap[channel](rest)

export default getGoToChannelUrl
